import { render, staticRenderFns } from "./download.vue?vue&type=template&id=3f7de34e&scoped=true&"
var script = {}
import style0 from "./download.vue?vue&type=style&index=0&id=3f7de34e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7de34e",
  null
  
)

export default component.exports